import { SameDayDeliveryStatus, SameDayDeliveryWeekNumbers } from '@shared/same-day-delivery/same-day-delivery.model';

export const secondsLeftToDate = (secondsLeft: number | undefined): Date => {
    if (!secondsLeft) {
        return new Date();
    }

    const endDate = new Date();
    endDate.setSeconds(endDate.getSeconds() + Math.round(secondsLeft) + 1);
    return endDate;
};

export const weekendModeDays: number[] = [
    SameDayDeliveryWeekNumbers.Friday,
    SameDayDeliveryWeekNumbers.Saturday,
    SameDayDeliveryWeekNumbers.Sunday
];
export const weekendMode = (dayOfWeek: number, onTimeForSameDayDelivery?: boolean): boolean => {
    // on friday after 13h is not available to show the same-day delivery, we are almost in weekend mode
    if (onTimeForSameDayDelivery && dayOfWeek === weekendModeDays[0]) {
        return false;
    }

    // we are in weekend mode and even if the onTimeForSameDayDelivery is true should be marked as weekend
    if (weekendModeDays.includes(dayOfWeek)) {
        // this should happen until sunday at midnight
        return true;
    }

    // to be in a week mode need to be before the 13 of Friday and after monday at 00:00
    return false;
};

export const getSameDayDeliveryStatus = (
    dayOfWeek: number,
    isHoliday?: boolean,
    onTimeForSameDayDelivery?: boolean,
    deliverToZipCode?: boolean
): SameDayDeliveryStatus => {
    if (deliverToZipCode) {
        const isWeekendMode = weekendMode(dayOfWeek, onTimeForSameDayDelivery);
        if (isWeekendMode) {
            return 'WeekendMode';
        }

        if (isHoliday) {
            return 'HolidayMode';
        }

        if (onTimeForSameDayDelivery) {
            return 'Valid';
        }

        return 'TimeIsUp';
    }

    // this is not very elegant but in case of undefined we don't want to verify this step
    if (deliverToZipCode === false) {
        return 'Invalid';
    }

    return 'Idle';
};
